import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
 

const NotFound: React.FC = () => {
 
  return (
    <div>
      <h1>Page Not Found</h1>
     
    </div>
  );
};

export default NotFound;
